export function parseCreated(original) {
  // return original
  const date = new Date(original);

  if (isNaN(date.getTime())) {
    return 'Date not found';
  }

  const dd = date.getDate().toString().padStart(2, '0');
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const yyyy = date.getFullYear();

  return `${dd}.${mm}.${yyyy}`;
}